import useProcuredOffer from '@/components/PackagePage/hooks/useProcuredOffer';
import usePropertyContent from '@/components/PackagePage/hooks/usePropertyContent';
import OfferModal from '@/v2/components/pages/PackageView/components/OfferModal';
import { useFlightModal } from '@/v2/components/pages/PackageView/contexts/FlightModalContext';
import { useRoomOptionsData } from '@/v2/components/pages/PackageView/contexts/RoomOptionsContext';
import { useGA4Events } from '@/v2/hooks/featureFlags/ga4Events/useGA4Events';
import dataLayer from '@/v2/utils/dataLayer';
import { useOfferModalControls } from '../../contexts/OfferModalControlsContext';
import {
  cancelOtherPackageDataLayerEvent,
  cancelUpgradePackageDataLayerEvent,
  popupAppearedDataLayerEvent,
  selectOtherPackageDataLayerEvent,
  selectUpgradePackageDataLayerEvent,
} from '../../utils/dataLayer/dataLayer';

const OfferModals = () => {
  // Global data
  const procuredOffer = useProcuredOffer();
  const propertyContent = usePropertyContent();
  const { upgradeOffer, selectedRoomOption } = useRoomOptionsData() || {};
  const { openFlightModal } = useFlightModal({
    roomId: selectedRoomOption?.roomType.id,
  });
  const shouldUseNewEvents = useGA4Events();

  // Controls
  const {
    isOtherOptionModalOpen,
    isUpgradeModalOpen,
    closeOtherOptionModal,
    closeUpgradeModal,
  } = useOfferModalControls();

  const handleIsUpgradeModalOpen = () => {
    if (isUpgradeModalOpen) {
      popupAppearedDataLayerEvent();
    }

    return isUpgradeModalOpen;
  };

  const handleUpgrade = async () => {
    if (shouldUseNewEvents) {
      dataLayer.ctaClickEvent({
        itemText: 'Upgrade package',
      });
    }
    await openFlightModal({
      offerId: upgradeOffer?.hotelOffer.id,
    });
    closeUpgradeModal();
    closeOtherOptionModal();
  };

  const handleOpenFlightModal = async () => {
    await openFlightModal({
      offerId: selectedRoomOption?.matchingOffer?.hotelOffer.id,
    });
    closeUpgradeModal();
    closeOtherOptionModal();
  };

  return (
    <>
      <OfferModal.Upgrade
        isOpen={handleIsUpgradeModalOpen()}
        onCancel={() => {
          cancelUpgradePackageDataLayerEvent();
          handleOpenFlightModal();
        }}
        onSubmit={() => {
          selectUpgradePackageDataLayerEvent();
          handleUpgrade();
        }}
        onClose={() => {
          cancelUpgradePackageDataLayerEvent();
          closeUpgradeModal();
        }}
        propertyContent={propertyContent}
        procuredOffer={procuredOffer}
        offer={upgradeOffer}
        roomType={selectedRoomOption?.roomType}
      />
      <OfferModal.OtherOption
        isOpen={isOtherOptionModalOpen}
        onCancel={() => {
          cancelOtherPackageDataLayerEvent();
          closeOtherOptionModal();
        }}
        onSubmit={() => {
          selectOtherPackageDataLayerEvent();
          handleUpgrade();
        }}
        onClose={() => {
          cancelOtherPackageDataLayerEvent();
          closeOtherOptionModal();
        }}
        propertyContent={propertyContent}
        procuredOffer={procuredOffer}
        offer={upgradeOffer}
        roomType={selectedRoomOption?.roomType}
      />
    </>
  );
};

export default OfferModals;
